<template>
  <input-select
    :id="id"
    v-model="model"
    :options="benefitings"
    :multiple="multiple"
    :max="limit"
    :is-loading="loader"
    :clearable="clearable"
    :close-on-select="false"
    :filterable="false"
    :placeholder="translate(placeholder)"
    :reduce="reduce"
    :reduce-attribute="reduceAttribute"
    :display-unmatched-option="displayUnmatchedOption"
    :label="label"
    :v="v"
    deselect-from-dropdown
    searchable
    paginable
  />
</template>

<script setup>
import { toRefs } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useBenefitingStore } from '@/stores/BenefitingStore'

import InputSelect from '&/atoms/InputSelect'

const model = defineModel({ type: [String, Array], default: () => [] })

const props = defineProps({
  id: { type: String },
  multiple: { type: Boolean, default: true },
  label: { type: String, default: 'name' },
  clearable: { type: Boolean, default: true },
  limit: { type: Number },
  placeholder: { type: String, default: '...' },
  reduce: { type: Function, default: benefiting => benefiting.id },
  reduceAttribute: { type: Function, default: benefiting => benefiting.id },
  displayUnmatchedOption: { type: Boolean, default: true },
  query: { type: Object, default: () => ({}) },
  v: Object
})

const { query } = toRefs(props)

const { translate } = useI18n()
const { getBenefitings } = useBenefitingStore()

const { benefitings, loader } = getBenefitings({ query: { per_page: 2000, view_format: 'page_selection', 'sort_by_field[field]': 'name', 'sort_by_field[direction]': 'asc', ...query.value } })
</script>
